"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Phone, Calendar } from "lucide-react";
const HERO_BG = "https://ddsalpha.com/wp-content/uploads/2026/05/Banner-Alpha-scaled-1.webp";
export default function BlogHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section ref={ref} className="relative flex items-center justify-center overflow-hidden py-16">
      {}
      <div className="absolute inset-0 bg-cover bg-center scale-105" style={{
      backgroundImage: `url(${HERO_BG})`,
      filter: "blur(4px)"
    }} />

      {}
      <div className="absolute inset-0 bg-black/45" />

      {}
      <div className="relative z-10 mx-auto max-w-4xl px-4 text-center sm:px-8">
        <h1 className={`mb-3 text-3xl font-bold text-white sm:text-4xl md:text-5xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Alpha Dental Blog
        </h1>

        <p className={`mb-6 text-base text-white/90 sm:text-lg md:text-xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Expert insights, dental care tips, and the latest from our practice to help you maintain a healthy, beautiful smile
        </p>

        <div className={`flex flex-col items-center justify-center gap-4 sm:flex-row transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Link to="tel:2107755177">
            <Button size="default" className="w-full bg-primary text-white hover:bg-primary-hover hover:-translate-y-0.5 hover:shadow-medium transition-all duration-[var(--duration-fast)] sm:w-auto">
              <Phone className="mr-2 size-5" />
              Call Now
            </Button>
          </Link>

          <Link to="https://www.appointnow.com/?P=4826&O=101&PT=0&campaignID=" newTab>
            <Button size="default" className="w-full bg-primary text-white hover:bg-primary-hover hover:-translate-y-0.5 hover:shadow-medium transition-all duration-[var(--duration-fast)] sm:w-auto">
              <SafeHydrate><Calendar className="mr-2 size-5" /></SafeHydrate>
              Schedule With Us
            </Button>
          </Link>

          <Link to="https://patientregistration.denticon.com/?P=4826&O=101&regPatID=0" newTab>
            <Button size="default" className="w-full bg-primary text-white hover:bg-primary-hover hover:-translate-y-0.5 hover:shadow-medium transition-all duration-[var(--duration-fast)] sm:w-auto">
              <SafeHydrate><Calendar className="mr-2 size-5" /></SafeHydrate>
              New Patient Registration
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}